module.exports = __webpack_public_path__ + "img/check.214b3188.svg";